import React, { useCallback, useState } from "react";

import { ServerDataSuccess } from "~/templates/product/route";
import { SizeAndFitSheet } from "~/templates/product/SizeAndFitSheet";

import { Button, IconMeasuringTape } from "@bared/ui";

interface SizeAndFitButtonProps {
  biomechanicalFootbed: ServerDataSuccess["biomechanicalFootbedSheetContents"];
  gender: "Mens" | "Womens";
  sheetFooterContent: ServerDataSuccess["template"]["sheetFooterContent"];
  sizeGuide: ServerDataSuccess["sizeGuideSheetContents"];
}

export function SizeButton({
  biomechanicalFootbed,
  gender,
  sheetFooterContent,
  sizeGuide,
}: SizeAndFitButtonProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSheetToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [isOpen]);

  return (
    <>
      <div>
        <Button
          variant="link"
          size="medium"
          onClick={handleSheetToggle}
          className="flex items-baseline font-medium"
        >
          <IconMeasuringTape className="w-mini" />
          Size Guide
        </Button>
      </div>

      <SizeAndFitSheet
        activeTab="sizeGuide"
        isOpen={isOpen}
        handleSheetToggle={handleSheetToggle}
        gender={gender}
        sizeGuide={sizeGuide}
        sheetFooterContent={sheetFooterContent}
        biomechanicalFootbed={biomechanicalFootbed}
      />
    </>
  );
}
